const divModalCloneCheck = {
  text1: 'O Checklist',
  text2: 'será clonado para o Tipo de Serviço e a Periodicidade selecionados.',
};

export default divModalCloneCheck;
